import { render, staticRenderFns } from "./CommunityModifyForm.vue?vue&type=template&id=58db45a7&scoped=true&"
import script from "./CommunityModifyForm.vue?vue&type=script&lang=js&"
export * from "./CommunityModifyForm.vue?vue&type=script&lang=js&"
import style0 from "./CommunityModifyForm.vue?vue&type=style&index=0&id=58db45a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58db45a7",
  null
  
)

export default component.exports